import React, { ReactNode } from 'react';
import c from 'classnames';
import { Trans } from 'react-i18next';

import { Row } from '../../helpers/costsTable';

import './style.scss';

interface Props {
  title?: string;
  className?: string;
  header?: ReactNode;
  data: Row[];
}

interface TableColumnProps {
  className?: string;
  children: ReactNode;
}

const TableHead: React.FC<TableColumnProps> = ({ className, children }) => {
  const classNames = c('TableHead', {
    ...(className && { [`TableHead--${className}`]: className }),
  });

  return (
    <th className={classNames}>
      {children}
    </th>
  );
};

const TableColumn: React.FC<TableColumnProps> = ({ className, children }) => {
  const classNames = c('TableColumn', {
    ...(className && { [`TableColumn--${className}`]: className }),
  });

  return (
    <td className={classNames}>
      {children}
    </td>
  );
};

const Table: React.FC<Props> = ({
  title,
  className,
  header,
  data,
}) => {
  const classNames = c(
    'Table',
    'responsive-figure-table',
    className,
  );

  return (
    <table className={classNames}>
      {title && (
        <caption>{title}</caption>
      )}
      <tbody>
        {header && header}
        {data.map((row) => (
          <tr key={row.id} className={c('TableRow', `TableRow--${row.id}`)}>
            {row.columns.map((column) => {
              const Column = column.head ? TableHead : TableColumn;

              return (
                <Column key={`${row.id}:${column.id}`} className={column.id}>
                  <Trans
                    i18nKey={`heat_calculator.costs_table.columns.${row.id}.${column.id}`}
                    values={column.values && column.values}
                  />
                </Column>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
